import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\PrismaController::stats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
export const stats = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: stats.url(args, options),
    method: 'get',
})

stats.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma-stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::stats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
stats.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return stats.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::stats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
stats.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::stats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
stats.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: stats.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::stats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
const statsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::stats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
statsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::stats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
statsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

stats.form = statsForm

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
export const snapshot = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: snapshot.url(args, options),
    method: 'get',
})

snapshot.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma/snapshot',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshot.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return snapshot.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshot.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshot.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: snapshot.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
const snapshotForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshotForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::snapshot
* @see Http/Controllers/PrismaController.php:65
* @route '/projects/{project}/prisma/snapshot'
*/
snapshotForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

snapshot.form = snapshotForm

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
export const reasons = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reasons.url(args, options),
    method: 'get',
})

reasons.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma/reasons',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasons.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return reasons.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasons.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reasons.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasons.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reasons.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
const reasonsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reasons.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasonsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reasons.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::reasons
* @see Http/Controllers/PrismaController.php:112
* @route '/projects/{project}/prisma/reasons'
*/
reasonsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reasons.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

reasons.form = reasonsForm

/**
* @see \App\Http\Controllers\PrismaController::updateReasons
* @see Http/Controllers/PrismaController.php:124
* @route '/projects/{project}/prisma/reasons'
*/
export const updateReasons = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateReasons.url(args, options),
    method: 'put',
})

updateReasons.definition = {
    methods: ["put"],
    url: '/projects/{project}/prisma/reasons',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\PrismaController::updateReasons
* @see Http/Controllers/PrismaController.php:124
* @route '/projects/{project}/prisma/reasons'
*/
updateReasons.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return updateReasons.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::updateReasons
* @see Http/Controllers/PrismaController.php:124
* @route '/projects/{project}/prisma/reasons'
*/
updateReasons.put = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateReasons.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\PrismaController::updateReasons
* @see Http/Controllers/PrismaController.php:124
* @route '/projects/{project}/prisma/reasons'
*/
const updateReasonsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateReasons.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PrismaController::updateReasons
* @see Http/Controllers/PrismaController.php:124
* @route '/projects/{project}/prisma/reasons'
*/
updateReasonsForm.put = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateReasons.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateReasons.form = updateReasonsForm

/**
* @see \App\Http\Controllers\PrismaController::deleteReasons
* @see Http/Controllers/PrismaController.php:141
* @route '/projects/{project}/prisma/reasons'
*/
export const deleteReasons = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteReasons.url(args, options),
    method: 'delete',
})

deleteReasons.definition = {
    methods: ["delete"],
    url: '/projects/{project}/prisma/reasons',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\PrismaController::deleteReasons
* @see Http/Controllers/PrismaController.php:141
* @route '/projects/{project}/prisma/reasons'
*/
deleteReasons.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return deleteReasons.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::deleteReasons
* @see Http/Controllers/PrismaController.php:141
* @route '/projects/{project}/prisma/reasons'
*/
deleteReasons.delete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteReasons.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\PrismaController::deleteReasons
* @see Http/Controllers/PrismaController.php:141
* @route '/projects/{project}/prisma/reasons'
*/
const deleteReasonsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteReasons.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PrismaController::deleteReasons
* @see Http/Controllers/PrismaController.php:141
* @route '/projects/{project}/prisma/reasons'
*/
deleteReasonsForm.delete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteReasons.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteReasons.form = deleteReasonsForm

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
export const exportMethod = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(args, options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethod.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return exportMethod.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethod.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethod.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
const exportMethodForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethodForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::exportMethod
* @see Http/Controllers/PrismaController.php:160
* @route '/projects/{project}/prisma/export'
*/
exportMethodForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

const PrismaController = { stats, snapshot, reasons, updateReasons, deleteReasons, exportMethod, export: exportMethod }

export default PrismaController